import type { ApiSkipLogic } from '../../../../internalTypes';
import type { SkipLogic } from '../../../../types/survey';
import { mapLogicFilterGroup } from './mapLogicFilters';

export function mapSkipLogics(raw: ApiSkipLogic[] | undefined): SkipLogic[] | undefined {
  if (!raw?.length) return undefined;

  const mapped = raw
    .map(item => {
      const id = item.id?.trim();
      const skipToId = item.skipTo?.id?.trim();
      const entityType = item.skipTo?.entityType;
      const condition = mapLogicFilterGroup(item.condition);

      if (!id || !skipToId || !entityType || !condition) return null;
      if (entityType !== 'QUESTION' && entityType !== 'END_OF_SURVEY') return null;

      return {
        id,
        skipTo: { id: skipToId, entityType },
        condition,
      } satisfies SkipLogic;
    })
    .filter((item): item is SkipLogic => item !== null);

  return mapped.length > 0 ? mapped : undefined;
}
